import { createStore } from '@frontend/store';

interface EIVWidgetState {
  isDismissed: boolean;
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
  toggleExpandCollapse: () => void;
  setIsDismissed: (isDismissed: boolean) => void;
}

export const useEIVWidgetStateStore = createStore<EIVWidgetState>(
  (set) => ({
    isDismissed: false,
    isCollapsed: false,
    setIsCollapsed: (isCollapsed: boolean) =>
      set(() => ({
        isCollapsed,
      })),
    toggleExpandCollapse: () =>
      set((state) => ({
        isCollapsed: !state.isCollapsed,
      })),
    setIsDismissed: (isDismissed: boolean) =>
      set(() => ({
        isDismissed,
      })),
  }),
  {
    name: 'eiv-trial-widget-state-store',
  }
);
